export const categories = [
  {
    slug: "rexue",
    name: "热血",
    description: "激情澎湃的战斗与冒险，点燃你的热血之魂",
    count: 128,
    image: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20epic%20battle%20scene%20warriors%20clashing%2C%20dramatic%20fire%20and%20energy%20effects%2C%20warm%20red%20and%20orange%20tones%2C%20action%20comics%20illustration%2C%20dynamic%20composition%2C%20clean%20gradient%20background&width=800&height=600&seq=category-rexue&orientation=landscape",
  },
  {
    slug: "lianai",
    name: "恋爱",
    description: "甜蜜浪漫的爱情故事，感受心动每一刻",
    count: 256,
    image: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romantic%20couple%20under%20cherry%20blossom%20trees%2C%20soft%20pink%20and%20peach%20tones%2C%20romance%20comics%20illustration%2C%20warm%20spring%20atmosphere%2C%20clean%20gradient%20background&width=800&height=600&seq=category-lianai&orientation=landscape",
  },
  {
    slug: "qihuan",
    name: "奇幻",
    description: "不可思议的异世界冒险，开启无限想象之旅",
    count: 203,
    image: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20fantasy%20world%20with%20floating%20islands%20and%20magical%20creatures%2C%20warm%20golden%20and%20emerald%20green%20tones%2C%20fantasy%20comics%20illustration%2C%20mystical%20atmosphere%2C%20clean%20gradient%20background&width=800&height=600&seq=category-qihuan&orientation=landscape",
  },
  {
    slug: "xuanyi",
    name: "悬疑",
    description: "扣人心弦的推理谜题，每一页都暗藏玄机",
    count: 87,
    image: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20mysterious%20detective%20scene%20in%20foggy%20alley%2C%20dark%20amber%20and%20deep%20brown%20tones%2C%20thriller%20comics%20illustration%2C%20suspenseful%20atmosphere%2C%20clean%20gradient%20background&width=800&height=600&seq=category-xuanyi&orientation=landscape",
  },
  {
    slug: "gaoxiao",
    name: "搞笑",
    description: "欢乐治愈的日常笑料，笑到停不下来",
    count: 95,
    image: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20funny%20chibi%20characters%20in%20colorful%20everyday%20situations%2C%20bright%20yellow%20and%20light%20green%20tones%2C%20comedy%20comics%20illustration%2C%20cheerful%20atmosphere%2C%20clean%20gradient%20background&width=800&height=600&seq=category-gaoxiao&orientation=landscape",
  },
  {
    slug: "xiaoyuan",
    name: "校园",
    description: "青春洋溢的校园生活，重温美好学生时代",
    count: 164,
    image: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20students%20in%20school%20campus%20with%20blooming%20flowers%2C%20warm%20ivory%20and%20soft%20blue%20sky%20tones%2C%20youth%20comics%20illustration%2C%20bright%20atmosphere%2C%20clean%20gradient%20background&width=800&height=600&seq=category-xiaoyuan&orientation=landscape",
  },
];

export const subcategories = [
  { slug: "wuxia", name: "武侠", parent: "rexue" },
  { slug: "gongting", name: "宫廷", parent: "lianai" },
  { slug: "maoxian", name: "冒险", parent: "qihuan" },
  { slug: "chuanyue", name: "穿越", parent: "qihuan" },
  { slug: "lingyi", name: "灵异", parent: "xuanyi" },
  { slug: "richang", name: "日常", parent: "gaoxiao" },
  { slug: "zichang", name: "职场", parent: "lianai" },
  { slug: "yineng", name: "异能", parent: "rexue" },
];